import PopoverMultiselectSystem from './PopoverMultiselectSystem';
import './PopoverMultiselectSystem.scss';

export default PopoverMultiselectSystem;
